import { cloneElement } from 'react';
import { isElement } from '../Popover/PopoverTarget/PopoverTarget.utils.mjs';
import { useMergedRef } from '../Popover/PopoverTarget/use-merged-ref.mjs';
import { useFocusTrap } from './FocusTrap.utils.mjs';

function FocusTrap({ children, active = true, refProp = "ref" }) {
  const focusTrapRef = useFocusTrap(active);
  const ref = useMergedRef(focusTrapRef, children?.ref);
  if (!isElement(children)) {
    return children;
  }
  return cloneElement(children, { [refProp]: ref });
}

export { FocusTrap };
